var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 27.5,
    height: 24.5,
    rx: 4.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 10.4143L8.59994 16.7075C8.2343 17.0975 7.63988 17.0975 7.27424 16.7075C6.90859 16.3175 6.90859 15.6835 7.27424 15.2935L13.8371 8.29326C14.2028 7.90225 14.7972 7.90225 15.1629 8.29326L21.7258 15.2935C22.0914 15.6835 22.0914 16.3175 21.7258 16.7075C21.3601 17.0975 20.7657 17.0975 20.4001 16.7075L14.5 10.4143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.b56f295b8b80eab194e9f4621a64600f.svg";
export { ForwardRef as ReactComponent };